<template>
    <div class="container-fluid">
        <section id="intro">
            <div id="particles-js"></div>
        </section>
    </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "openingHome",
  data() {
    return {
      changeDisplay: false
    };
  },
  mounted() {
    window.particlesJS.load(
      "particles-js",
      "/static/assets/js/particles/particles.json",
      null
    );

    firebase
        .database()
        .ref("display")
        .set({
          changeDisplay: false
        });

    // Check Change Value
    firebase
      .database()
      .ref("display/changeDisplay")
      .on("value", snapshot => {
        // this.changeDisplay = snapshot.val();
        console.log(snapshot.val())
        if (snapshot.val() === true) {
          this.$router.push("openingResult");
        }
      });
  },
  methods: {

  }
//   updated: function () {
//   this.$nextTick(function () {
//     // Check Change Value
//     firebase
//       .database()
//       .ref("display/changeDisplay")
//       .on("value", snapshot => {
//         this.changeDisplay = snapshot.val();
//       });

//       if (this.changeDisplay === true) {
//           this.$router.push("openingResult");
//         }
//   })
// }
};
</script>

<style>
.fullscreen {
  min-height: 100vh;
}

.container-fluid {
  padding: 0;
  background: linear-gradient(#8e1625, #240b36);
  overflow: hidden;
}

/* Intro */
#intro {
  background: url("/static/assets/img/intro_bg.svg") center no-repeat;
  background-size: cover;
  height: 100vh;
}
#particles-js {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/opening/openingHome.vue